(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();
  ready(() => {
    if (!document.querySelector('[data-elfine-home]')) return;

    const style = document.createElement('style');
    style.textContent = `
      .elfine-product-grid{display:flex!important;overflow-x:auto!important;overflow-y:hidden!important;gap:18px!important;padding:0 2px 18px!important;scroll-snap-type:x mandatory!important;scrollbar-width:none!important;-webkit-overflow-scrolling:touch!important;overscroll-behavior-inline:contain!important}
      .elfine-product-grid::-webkit-scrollbar{display:none!important}
      .elfine-product-card{flex:0 0 calc((100% - 54px)/3.25)!important;width:auto!important;max-width:none!important;scroll-snap-align:start!important}
      @media(max-width:1099px){.elfine-product-card{flex-basis:44vw!important}}
      @media(max-width:749px){
        .elfine-product-section.elfine-shell{width:100%!important;max-width:none!important;margin-inline:0!important}
        .elfine-product-grid{gap:12px!important;padding:0 0 22px 14px!important;scroll-padding-left:14px!important;align-items:stretch!important}
        .elfine-product-card{flex:0 0 clamp(224px,66vw,300px)!important;width:clamp(224px,66vw,300px)!important;max-width:none!important;min-width:0!important;display:flex!important;flex-direction:column!important;height:auto!important}
        .elfine-product-card__media{width:100%!important;aspect-ratio:1/1!important;flex:0 0 auto!important}
        .elfine-product-card__details{display:flex!important;flex:1 1 auto!important;flex-direction:column!important;min-width:0!important;padding:14px 12px 12px!important}
        .elfine-product-card__details>div{display:block!important;min-width:0!important;width:100%!important}
        .elfine-product-card__details>div>a{display:block!important;min-width:0!important}
        .elfine-product-card__details h3{display:-webkit-box!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:2!important;overflow:hidden!important;min-height:2.5em!important;margin:0!important;font-size:17px!important;line-height:1.25!important;word-break:normal!important;overflow-wrap:normal!important}
        .elfine-product-card__details p{display:flex!important;flex-wrap:wrap!important;align-items:center!important;gap:5px!important;margin:8px 0 0!important;font-size:13px!important;line-height:1.2!important;white-space:normal!important}
        .elfine-product-card__details p .compare-at-price,.elfine-product-card__details p .price{white-space:nowrap!important}
        .elfine-quick-add{display:grid!important;grid-template-columns:minmax(0,.9fr) minmax(0,1.25fr)!important;gap:8px!important;width:100%!important;margin-top:auto!important;padding-top:14px!important}
        .elfine-quick-add label{min-width:0!important;width:100%!important}
        .elfine-quick-add select,.elfine-quick-add button{width:100%!important;min-width:0!important;min-height:44px!important;height:44px!important;padding:0 9px!important;font-size:10px!important;line-height:1!important;white-space:nowrap!important}
        .elfine-product-grid::after{content:'';flex:0 0 14px}
      }
      @media(max-width:359px){
        .elfine-product-card{flex-basis:72vw!important;width:72vw!important}
        .elfine-product-card__details{padding-inline:10px!important}
        .elfine-product-card__details h3{font-size:16px!important}
        .elfine-quick-add{grid-template-columns:minmax(0,.88fr) minmax(0,1.12fr)!important;gap:6px!important}
        .elfine-quick-add select,.elfine-quick-add button{font-size:9px!important;padding-inline:6px!important}
      }
    `;
    document.head.appendChild(style);

    const money = (amount) => {
      const currency = window.Shopify?.currency?.active || 'PKR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(Number(amount));
      } catch (_) {
        return `${currency} ${Number(amount).toFixed(2)}`;
      }
    };

    const escapeHtml = (value='') => String(value).replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));

    const buildCard = (product) => {
      const firstVariant = product.variants?.find(v => v.available) || product.variants?.[0];
      const image1 = product.images?.[0]?.src || '';
      const image2 = product.images?.[1]?.src || '';
      const original = Number(firstVariant?.price || 0);
      const discounted = original * 0.9;
      const options = (product.variants || []).map(v => `<option value="${v.id}"${v.available ? '' : ' disabled'}>${escapeHtml(v.title)}</option>`).join('');
      const select = (product.variants || []).length > 1 ? `<label><span class="visually-hidden">Choose size</span><select name="id" aria-label="Choose size for ${escapeHtml(product.title)}">${options}</select></label>` : `<input type="hidden" name="id" value="${firstVariant?.id || ''}">`;
      const secondary = image2 ? `<img src="${escapeHtml(image2)}" loading="lazy" class="elfine-product-card__image elfine-product-card__image--secondary" alt="${escapeHtml(product.title)}">` : '';
      const card = document.createElement('article');
      card.className = 'elfine-product-card is-revealed';
      card.dataset.elfineProductHandle = product.handle;
      card.innerHTML = `
        <a href="/products/${escapeHtml(product.handle)}" class="elfine-product-card__media">
          ${image1 ? `<img src="${escapeHtml(image1)}" loading="lazy" class="elfine-product-card__image elfine-product-card__image--primary" alt="${escapeHtml(product.title)}">` : ''}
          ${secondary}
          ${(product.tags || '').toString().includes('new-arrival') ? '<span>New</span>' : ''}
        </a>
        <div class="elfine-product-card__details">
          <div>
            <a href="/products/${escapeHtml(product.handle)}"><h3>${escapeHtml(product.title)}</h3></a>
            <p><s class="compare-at-price">${money(original)}</s> <span class="price">${money(discounted)}</span></p>
          </div>
          <form method="post" action="/cart/add" class="elfine-quick-add">
            ${select}
            <button type="submit" name="add"${firstVariant?.available ? '' : ' disabled'}>${firstVariant?.available ? 'Add to bag' : 'Sold out'}</button>
          </form>
        </div>`;
      return card;
    };

    document.querySelectorAll('.elfine-product-section').forEach(async (section) => {
      const grid = section.querySelector('.elfine-product-grid');
      const viewAll = section.querySelector('.elfine-section-heading a[href*="/collections/"]');
      if (!grid || !viewAll) return;
      const match = viewAll.getAttribute('href')?.match(/\/collections\/([^/?#]+)/);
      const handle = match?.[1];
      if (!handle) return;

      grid.querySelectorAll('.elfine-product-card').forEach(card => {
        const href = card.querySelector('.elfine-product-card__media')?.getAttribute('href') || '';
        const h = href.match(/\/products\/([^/?#]+)/)?.[1];
        if (h) card.dataset.elfineProductHandle = h;
      });
      const existing = new Set([...grid.querySelectorAll('[data-elfine-product-handle]')].map(el => el.dataset.elfineProductHandle));

      try {
        const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        (data.products || []).forEach(product => {
          if (existing.has(product.handle)) return;
          grid.appendChild(buildCard(product));
          existing.add(product.handle);
        });
      } catch (_) {}
    });
  });
})();
